import {ToggleButton, ToggleButtonGroup} from '@mui/material';

interface IProps<T = unknown> {
    options: readonly T[];
    onSelect: (option: T) => void;
    value?: T;
    getOptionLabel: (option: T) => string;
    getOptionValue: (option: T) => string | number;
}

export const MeinToggle = <T,>({
    onSelect,
    options,
    value,
    getOptionLabel,
    getOptionValue,
}: IProps<T>) => {
    const handleChange = (_: unknown, value: T) => {
        onSelect(options.find(o => getOptionValue(o) === value)!);
    };

    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={handleChange}
            aria-label="text alignment"
        >
            {options.map(o => (
                <ToggleButton key={getOptionValue(o)} value={getOptionValue(o)}>
                    {getOptionLabel(o)}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};
